import { useRef, useState } from 'react';

import { useClickOutside } from '@controlrooms/hooks';

export interface DropdownState {
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
  ref: React.RefObject<HTMLDivElement>;
}

/**
 * Generic hook for managing dropdown state with click outside functionality
 * @param initialOpen - Initial open state (default: false)
 * @returns DropdownState object with state and handlers
 */
export const useDropdownState = (initialOpen = false): DropdownState => {
  const [isOpen, setIsOpen] = useState(initialOpen);
  const ref = useRef<HTMLDivElement>(null);

  const toggle = () => setIsOpen((prev) => !prev);
  const close = () => setIsOpen(false);

  useClickOutside(ref, close);

  return {
    isOpen,
    toggle,
    close,
    ref,
  };
};
